import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { apiFetch } from '../../api/client'
import type { Role } from '../../auth/types'

export interface UserListItem {
  id: string
  displayName: string
  email: string
  role: Role
  isActive: boolean
  lastSignInAt: string | null
}

const usersKey = ['users'] as const

export function useUsers() {
  return useQuery({
    queryKey: usersKey,
    queryFn: () => apiFetch<UserListItem[]>('/api/users'),
  })
}

export function useChangeRole() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ id, role }: { id: string; role: Role }) =>
      apiFetch<void>(`/api/users/${id}/role`, { method: 'PUT', body: { role } }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: usersKey }),
  })
}

export function useSetActive() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ id, isActive }: { id: string; isActive: boolean }) =>
      apiFetch<void>(`/api/users/${id}/${isActive ? 'reactivate' : 'deactivate'}`, {
        method: 'POST',
      }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: usersKey }),
  })
}
